module.exports = __webpack_public_path__ + "img/welcome-widget-guru.53e7cdfb.png";